<template>
    <alert-modal backdrop="static" :button="data.button" :close="false" @hidden="close" ref="modal">
        <div class="font-weight:700">{{ data.title }}</div>
        <div class="f:20 font-weight:normal mt:24 mb:48 color:gray02 text:left">{{ data.content }}</div>
    </alert-modal>
</template>

<script setup>
    const data = ref({});
    const modal = ref();

    const close = () => {
        if (data.value.url) {
            window.open(data.value.url, "_blank");
        }
    };

    watch(modal, () => {
        const today = new Date().toLocaleDateString();

        if (localStorage.popupAdsDate !== today) {
            api("api/popup-ads").done((res) => {
                if (res.success && res.data.length) {
                    const prev = [];
                    const next = [];

                    let found = false;

                    res.data.forEach((ads) => {
                        if (found) {
                            next.push(ads);
                        } else {
                            prev.push(ads);

                            if (ads.id == localStorage.popupAdsId) {
                                found = true;
                            }
                        }
                    });

                    const list = next.concat(prev);

                    data.value = list[0];

                    localStorage.popupAdsDate = today;
                    localStorage.popupAdsId = data.value.id;

                    modal.value.show();
                }
            });
        }
    });
</script>
